import type { Template } from "@/types";

export const PO_06_H5_V1: Template[] = [
    {
        id: "po-06-h5v1-01",
        name: "PO 01 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_01.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 39, y: 151, width: 370, height: 519, rotation: 0, imageRotation: 0 },
            { id: "2", x: 703, y: 231, width: 562, height: 357, rotation: 0, imageRotation: 0 },
            { id: "3", x: 416, y: 151, width: 203, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 416, y: 283, width: 203, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 416, y: 415, width: 203, height: 124, rotation: 0, imageRotation: 0 },
            { id: "6", x: 416, y: 547, width: 203, height: 123, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-02",
        name: "PO 02 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_02.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 59, y: 228, width: 256, height: 364, rotation: 0, imageRotation: 0 },      
            { id: "2", x: 323, y: 228, width: 286, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 323, y: 414, width: 286, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 709, y: 156, width: 535, height: 333, rotation: 0, imageRotation: 0 },
            { id: "5", x: 709, y: 497, width: 264, height: 166, rotation: 0, imageRotation: 0 },
            { id: "6", x: 981, y: 497, width: 263, height: 166, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-03",
        name: "PO 03 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_03.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 47, y: 231, width: 562, height: 357, rotation: 0, imageRotation: 0 },
            { id: "2", x: 692, y: 151, width: 369, height: 518, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1069, y: 151, width: 203, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1069, y: 283, width: 203, height: 124, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1069, y: 415, width: 203, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 546, width: 203, height: 123, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-04",
        name: "PO 04 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_04.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 93, y: 111, width: 473, height: 292, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 93, y: 410, width: 233, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 93, y: 564, width: 233, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 334, y: 410, width: 233, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 334, y: 564, width: 233, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 769, y: 111, width: 428, height: 598, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-05",
        name: "PO 05 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_05.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 62, y: 244, width: 532, height: 333, rotation: 0, imageRotation: 0 },
            { id: "2", x: 726, y: 539, width: 166, height: 217, rotation: 0, imageRotation: 0 },
            { id: "3", x: 899, y: 539, width: 340, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 726, y: 64, width: 514, height: 301, rotation: 0, imageRotation: 0 },
            { id: "5", x: 726, y: 372, width: 254, height: 160, rotation: 0, imageRotation: 0 },
            { id: "6", x: 987, y: 372, width: 253, height: 160, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-06",
        name: "PO 06 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_06.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 782, y: 230, width: 529, height: 360, rotation: 0, imageRotation: 0 },
            { id: "2", x: 537, y: 230, width: 237, height: 360, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 230, width: 261, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 0, y: 414, width: 261, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 269, y: 230, width: 260, height: 176, rotation: 0, imageRotation: 0 },
            { id: "6", x: 269, y: 414, width: 260, height: 176, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-07",
        name: "PO 07 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_07.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 0, y: 174, width: 333, height: 473, rotation: 0, imageRotation: 0 },
            { id: "2", x: 542, y: 174, width: 770, height: 473, rotation: 0, imageRotation: 0 },
            { id: "3", x: 340, y: 174, width: 195, height: 113, rotation: 0, imageRotation: 0 },
            { id: "4", x: 340, y: 295, width: 195, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 340, y: 416, width: 195, height: 112, rotation: 0, imageRotation: 0 },
            { id: "6", x: 340, y: 536, width: 195, height: 112, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-08",
        name: "PO 08 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_08.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 64, y: 496, width: 262, height: 158, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 129, width: 262, height: 360, rotation: 0, imageRotation: 0 },
            { id: "3", x: 333, y: 129, width: 425, height: 259, rotation: 0, imageRotation: 0 },
            { id: "4", x: 333, y: 395, width: 425, height: 259, rotation: 0, imageRotation: 0 },
            { id: "5", x: 765, y: 129, width: 425, height: 259, rotation: 0, imageRotation: 0 },
            { id: "6", x: 765, y: 395, width: 425, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-09",
        name: "PO 09 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_09.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 64, y: 132, width: 215, height: 282, rotation: 0, imageRotation: 0 },
            { id: "2", x: 286, y: 132, width: 448, height: 282, rotation: 0, imageRotation: 0 },
            { id: "3", x: 741, y: 132, width: 448, height: 282, rotation: 0, imageRotation: 0 },
            { id: "4", x: 64, y: 421, width: 371, height: 232, rotation: 0, imageRotation: 0 },
            { id: "5", x: 442, y: 421, width: 370, height: 232, rotation: 0, imageRotation: 0 },
            { id: "6", x: 819, y: 421, width: 370, height: 232, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-10",
        name: "PO 10 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_10.png",
        size: [1311, 820],
        style: {},
        slots: [
            { id: "1", x: 397, y: 115, width: 420, height: 590, rotation: 0, imageRotation: 0 },
            { id: "2", x: 84, y: 115, width: 305, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 84, y: 315, width: 305, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 84, y: 514, width: 305, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 825, y: 115, width: 423, height: 291, rotation: 0, imageRotation: 0 },
            { id: "6", x: 825, y: 414, width: 423, height: 291, rotation: 0, imageRotation: 0 }
        ],
    }
];